import React from "react";
const STROKE_COLOR = getComputedStyle(document.documentElement)
	.getPropertyValue("--icon-stroke-color")
	.trim();
const ArrowRight = (props) => {
	return (
		<svg
			width="30"
			height="31"
			viewBox="0 0 30 31"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<rect
				x="29.5"
				y="29.8359"
				width="29"
				height="29"
				rx="14.5"
				transform="rotate(-180 29.5 29.8359)"
				stroke={STROKE_COLOR}
			/>
			<path
				d="M13 20.3359L18.0781 16.1042C18.5579 15.7044 18.5579 14.9675 18.0781 14.5677L13 10.3359"
				stroke={STROKE_COLOR}
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	);
};

export default ArrowRight;
